var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PanelContainer',{staticClass:"panel",attrs:{"id":"languagepanel","usage":"launcher","modal":true,"modalParentId":"mainpanel"}},[_c('LanguageSelectBoxConnected',{staticClass:"h-100"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }